
import { defineComponent } from "vue";
import CodeHighlighter from "@/components/highlighters/CodeHighlighter.vue";

export default defineComponent({
  name: "z-index",
  components: {
    CodeHighlighter,
  },
  setup() {
    const zIndexValues = ["-1", "-2", "0", "1", "2", "3"];
    const zIndexPoints = ["n1", "n2", "0", "1", "2", "3"];

    return {
      zIndexValues,
      zIndexPoints,
    };
  },
});
